export const themes = [
    {
        title:'Qonunlar va boshqa normativ-huquqiy hujjatlarni qo`llash masalalari bo`yocha maslahatlar berishning o`ziga xos jihatlari',
        isActives:true
    },
    {
        title:'Qonunlar va boshqa normativ-huquqiy hujjatlarni qo`llash masalalari bo`yocha maslahatlar berishning o`ziga xos jihatlari',
        isActives:false
    },
    {
        title:'Qonunlar va boshqa normativ-huquqiy hujjatlarni qo`llash masalalari bo`yocha maslahatlar berishning o`ziga xos jihatlari',
        isActives:false
    },
    {
        title:'Qonunlar va boshqa normativ-huquqiy hujjatlarni qo`llash masalalari bo`yocha maslahatlar berishning o`ziga xos jihatlari',
        isActives:false
    },
    {
        title:'Qonunlar va boshqa normativ-huquqiy hujjatlarni qo`llash masalalari bo`yocha maslahatlar berishning o`ziga xos jihatlari',
        isActives:false
    },
    {
        title:'Qonunlar va boshqa normativ-huquqiy hujjatlarni qo`llash masalalari bo`yocha maslahatlar berishning o`ziga xos jihatlari',
        isActives:false
    },
    {
        title:'Qonunlar va boshqa normativ-huquqiy hujjatlarni qo`llash masalalari bo`yocha maslahatlar berishning o`ziga xos jihatlari',
        isActives:false
    },

] 